__turbopack_context__.v({
  "group": "index-module-scss-module__qzV_3q__group",
  "group-links": "index-module-scss-module__qzV_3q__group-links",
  "link": "index-module-scss-module__qzV_3q__link",
});
